export default __webpack_public_path__ + "static/media/toggleshow.8b90d7ce.svg";